// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import axios from 'axios';
import VueResource from 'vue-resource';
import util from './util/index';
import './config/env';
import './assets/css/my-mint.scss';
import 'mint-ui/lib/style.css';
import 'vant/lib/index.css';
import Vant from 'vant';

Vue.config.productionTip = false;
Vue.prototype.ajax = axios;
Vue.use(VueResource);
Vue.use(Vant);

router.beforeEach((to, from, next) => {
	if (to.meta.title) {
		document.title = to.meta.title;
	} else {
		document.title = '虚贝租号-专业租号平台';
	}
	next();
});
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: { App },
	template: '<App/>'
});

function onBridgeReady() {
	WeixinJSBridge.call('hideToolbar');
}

if (typeof WeixinJSBridge == 'undefined') {
	if (document.addEventListener) {
		document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
	} else if (document.attachEvent) {
		document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
		document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
	}
} else {
	onBridgeReady();
}



// WEBPACK FOOTER //
// ./src/main.js